module.exports = __webpack_public_path__ + "media/images/flags/32/Paraguay-8be383739a038a6bbcfb440deda236a7.png";